import { render } from "./portrait_guangon.vue?vue&type=template&id=09ecf464&scoped=true"
import script from "./portrait_guangon.vue?vue&type=script&lang=js"
export * from "./portrait_guangon.vue?vue&type=script&lang=js"

import "./portrait_guangon.vue?vue&type=style&index=0&id=09ecf464&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ecf464"]])

export default __exports__